import Markdown from 'markdown-to-jsx';
import { useMemo } from 'react';

export default function StandartPrivacy({ data, flag }) {
    const countriesLocalizationsData = useMemo(
        () =>
            data?.reduce((acc, el) => {
                acc[el.lang] = { privacy_policy: el.privacy_policy };
                return acc;
            }, {}),
        [data],
    );
    return (
        <div className="table-wrapper">
            <div className="markdown-wrapper">
                <Markdown>
                    {countriesLocalizationsData?.[flag]?.privacy_policy ||
                        'No Privacy Policy added'}
                </Markdown>
            </div>
        </div>
    );
}
